import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RepeatOrderService {

  // private apiUrl = "http://localhost:3003/api";
  apiUrl = "https://lexipackghana.com:3003/api";


  constructor(private http: HttpClient) { }

  repeatOrder(data: any) {
    console.log('Sending Data:', data); // Add this line for debugging
    return this.http.post(this.apiUrl + '/repeatOrders', data);
  }
  
getAllRepeatOrder(){
  return this.http.get(this.apiUrl+'/getAllRepeatOrders');
}
getAllRepeatOrdersDisp(){
  return this.http.get(this.apiUrl+'/getAllRepeatOrdersDisp');
}
 
getRepeatOrderById(RepeatOrderId: string) {

  return this.http.get(this.apiUrl+'/getRepeatOrdersById/'+RepeatOrderId);
}
  // New method to update a repeated order by ID
  updateRepeatOrder(orderId: string, updatedData: any) {
    console.log('Updating Data:', updatedData); // For debugging
    return this.http.put(this.apiUrl + '/updateRepeatOrder/' + orderId, updatedData);
  }
deleteRepeatOrder(RepeatOrderId: string) {
  return this.http.delete(this.apiUrl+'/deleteRepeatById/'+RepeatOrderId);
}

// getAllRepeatOrdersTicket(){
//   return this.http.get(this.apiUrl+'/getAllRepeatOrdersTicket');
// }
}

